import React, { Component, Fragment } from 'react';
import { Grid, Button, Checkbox, Icon } from 'semantic-ui-react';
import './PromoPopup.css';

class PromoPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: props.isVisible || false,
      dontShowForever: false,
    };
  }

  componentDidMount() {
    // 팝업 표시 여부 체크
    this.checkPopupVisibility();
  }

  checkPopupVisibility = () => {
    const today = new Date().toDateString();
    const lastHidden = localStorage.getItem('promoPopupHiddenDate');

    // 오늘 숨김 처리된 경우 표시하지 않음
    if (lastHidden === today) {
      this.setState({ isVisible: false });
      return;
    }

    // 완전히 숨김 처리된 경우
    const isPermanentlyHidden = localStorage.getItem(
      'promoPopupPermanentlyHidden'
    );
    if (isPermanentlyHidden === 'true') {
      this.setState({ isVisible: false });
      return;
    }

    // 팝업 표시
    this.setState({ isVisible: true });
  };

  handleClose = () => {
    const { dontShowForever } = this.state;

    if (dontShowForever) {
      // 다시 보지 않기 처리 - 영구적으로 숨김
      localStorage.setItem('promoPopupPermanentlyHidden', 'true');
      localStorage.removeItem('promoPopupHiddenDate'); // 기존 임시 숨김 데이터 제거
    } else {
      // 체크하지 않고 닫은 경우 - 다음날 자정 이후 다시 표시
      const today = new Date().toDateString();
      localStorage.setItem('promoPopupHiddenDate', today);
    }

    this.setState({ isVisible: false });

    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  handleCheckboxChange = (e, { checked }) => {
    this.setState({ dontShowForever: checked });
  };

  handleVisitSite = () => {
    window.open('https://api.natmal.com', '_blank');
    this.handleClose();
  };

  render() {
    const { isVisible } = this.state;

    if (!isVisible) {
      return null;
    }

    return (
      <Fragment>
        {/* 배경 오버레이 */}
        <div className="promo-popup-overlay" onClick={this.handleClose}></div>

        {/* 팝업 컨테이너 */}
        <div className="promo-popup-container">
          {/* 팝업 본문 */}
          <div className="promo-popup-content">
            {/* 닫기 버튼 (우상단 X) */}
            <button
              className="promo-popup-close-btn promo-popup-close-btn-white"
              onClick={this.handleClose}
              aria-label="팝업 닫기"
            >
              <Icon name="close" />
            </button>

            <div className="promo-popup-main-text">
              <h3>API 서비스 출시</h3>
              <p className="promo-popup-subtitle">
                개발자를 위한 강력한 언어처리 API 서비스
              </p>
            </div>

            <div className="promo-popup-features">
              <div className="feature-item">
                <Icon name="check circle" color="green" />
                <span>통합 한국어 처리 솔루션</span>
              </div>
              <div className="feature-item">
                <Icon name="check circle" color="green" />
                <span>원클릭 API 연동</span>
              </div>
              <div className="feature-item">
                <Icon name="check circle" color="green" />
                <span>대량 텍스트 데이터 분석</span>
              </div>
              <div className="feature-item">
                <Icon name="check circle" color="green" />
                <span>개발자 친화적 RESTful API</span>
              </div>
            </div>

            <div className="promo-popup-description">
              <p>
                유의어 추천부터 문서의 난이도 측정까지, 낱말에서 제공하는 다양한
                한국어 처리 솔루션을 하나의 API로 연동해 보세요.
              </p>
            </div>

            <div className="promo-popup-cta">
              <Button
                color="orange"
                size="large"
                onClick={this.handleVisitSite}
                className="promo-popup-main-btn"
              >
                <Icon name="external" />
                지금 확인하기
              </Button>
            </div>
          </div>

          {/* 팝업 하단 */}
          <div className="promo-popup-footer">
            <Grid>
              <Grid.Column floated="left" width={10}>
                <Checkbox
                  label="다시 보지 않기"
                  onChange={this.handleCheckboxChange}
                  className="promo-popup-checkbox"
                />
              </Grid.Column>
              <Grid.Column textAlign="right" floated="right" width={6}>
                <Button
                  basic
                  onClick={this.handleClose}
                  className="promo-popup-close-text-btn"
                >
                  닫기
                </Button>
              </Grid.Column>
            </Grid>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default PromoPopup;
